import styled from 'styled-components';

export const ClassicSwitchLink = styled.a`
  :hover span {
    color: ${p => p.theme.text.callToActionHover};
  }
`;
